import { baseService } from '../base';
import {
  TRateTypeDiscount,
  TCreateRateTypeDiscount,
  TUpdateRateTypeDiscount,
} from '~/types/rate-type-discount';

export const getRateTypeDiscounts = async (): Promise<TRateTypeDiscount[]> => {
  const { data } = await baseService.get<TRateTypeDiscount[]>('/rate-type-discounts');
  return data;
};

export const getRateTypeDiscount = async (
  id: string,
): Promise<TRateTypeDiscount> => {
  const { data } = await baseService.get<TRateTypeDiscount>(`/rate-type-discounts/${id}`);
  return data;
};

export const createRateTypeDiscount = async (
  payload: TCreateRateTypeDiscount,
): Promise<TRateTypeDiscount> => {
  const { data } = await baseService.post<TRateTypeDiscount>('/rate-type-discounts', payload);
  return data;
};

export const updateRateTypeDiscount = async (
  id: string,
  payload: TUpdateRateTypeDiscount,
): Promise<TRateTypeDiscount> => {
  const { data } = await baseService.patch<TRateTypeDiscount>(
    `/rate-type-discounts/${id}`,
    payload,
  );
  return data;
};

export const deleteRateTypeDiscount = async (id: string): Promise<void> => {
  await baseService.delete(`/rate-type-discounts/${id}`);
};
